import React from 'react';

const NewsletterSection = () => {
    return (
        <section id="booking" className="py-24 bg-[#E0D4FC] text-purple-950">
            <div className="container mx-auto px-6 text-center max-w-3xl">
                <h2 className="serif text-4xl md:text-5xl mb-6">Don't Miss the Next Drop.</h2>
                <p className="text-purple-900/70 mb-10 text-lg">Our appointment books open on the 25th of every month. Join the VIP list to get the booking link 1 hour before the public.</p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-lg mx-auto">
                    <input type="email" placeholder="Enter your email" className="w-full px-6 py-4 rounded-full border-none focus:ring-2 focus:ring-purple-900 outline-none placeholder-purple-900/40 bg-white/50 backdrop-blur" />
                    <button className="bg-purple-950 text-white px-8 py-4 rounded-full font-bold uppercase tracking-widest hover:bg-black transition-colors shrink-0">
                        Join List
                    </button>
                </div>
                <p className="text-xs mt-6 opacity-60">No spam. Just nails.</p>
            </div>
        </section>
    );
};

export default NewsletterSection;
